import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-15/task-02";

const task: Slide = {
  titleHtml:
    "The open-loop bandwidth sensitivity of a ribbon microphone is controlled by its<br>(multiple answers allowed).",
  description: "Select the correct answer(s).",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
